import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { PropertyForm } from '@/types/requests/property'
import { AddresSearchHint, AddressDetails, Property, PropertyDetails } from '@/types/unlock'

export const propertyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPropertyByExternalId: builder.query<Property, string>({
      query: (externalId) => `v2/properties/${externalId}/`,
    }),
    getProperty: builder.query<Property, any>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/property/`,
      providesTags: ['PropertyV2', 'Liens', 'Tradeline', 'Payoffs'],
    }),
    updateProperty: builder.mutation<Property, Partial<PropertyForm>>({
      query: (body) => ({
        method: 'PATCH',
        url: `v2/properties/${body.uuid}/`,
        body,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'AutomatedApplicationExceptions',
        'PropertyV2',
        'Override',
        'Liens',
        'Tradeline',
        'Payoffs',
        'Address',
        'ChecklistGroups',
        'MaxActions',
        'ApplicationExceptions',
        'Escalations',
        'Alert',
        'ApplicationProfiles',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:application']))
      },
    }),

    getAddressList: builder.mutation<AddresSearchHint[], string>({
      query: (userInput) => ({
        url: '/find-address',
        method: 'POST', // why POST and not GET? ask the backend :shrugh:
        body: { query: userInput },
      }),
    }),

    getAddressDetails: builder.mutation<AddressDetails, AddresSearchHint>({
      query: (address) => ({
        url: '/address-details',
        method: 'POST', // POST is just for the sake of the backend
        body: { address },
      }),
    }),

    newGetAddressList: builder.mutation<AddresSearchHint[] | string[], any>({
      query: ({ query, ...params }) => {
        return {
          url: '/find-address',
          method: 'POST',
          body: { query },
          params: params,
        }
      },
    }),

    newGetAddressDetails: builder.mutation<AddressDetails, any>({
      query: ({ address, ...params }) => {
        return {
          url: '/address-details',
          method: 'POST',
          body: { address },
          params: params,
        }
      },
    }),
    getUserApplications: builder.query<any, any>({
      query: (external_id) => `v2/user/${external_id}/applications/`,
    }),
    getPropertyDetails: builder.query<PropertyDetails, any>({
      query: (external_id) => `v2/applications/${external_id}/property-details/`,
      providesTags: ['PropertyDetails'],
    }),
  }),
  overrideExisting: true,
})

export const {
  useGetPropertyByExternalIdQuery,
  useUpdatePropertyMutation,
  useGetAddressListMutation,
  useGetAddressDetailsMutation,
  useGetPropertyQuery,
  useNewGetAddressDetailsMutation,
  useNewGetAddressListMutation,
  useLazyGetUserApplicationsQuery,
  useGetPropertyDetailsQuery,
} = propertyApi
